var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.getUser)?_c('div',{staticClass:"home"},[_c('main',[_c('div',{staticClass:"father"},[(_vm.load)?_c('router-view'):_vm._e()],1)]),_c('header',[_c('Header')],1),_c('nav',[_c('Sidebar')],1),_c('AnnouncementPopup')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }